import React from "react";
import Image from "next/image";

interface Block {
  title: string;
  description?: string;
  Description?: string;
  link: {
    href: string;
    label: string;
  };
}
interface Props {
  block: Block;
}
const Feedback: React.FC<Props> = ({ block }) => {
  return (
    <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
      <div className="container">
        <div className={` mb-[32px] lg:mb-[32px] xl:mb-[40px] `}>
          <h2 className="text-center  font-bold  text-heading-1 text-primary-text mb-[12px]">
            {block?.title ?? ""}
          </h2>
          <p className="text-heading-6 font-regular text-gray-700 text-center">
            {block?.Description ?? block?.description ?? ""}
          </p>
        </div>
        <div className="flex items-center justify-center">
          <button
            type="button"
            aria-label="button"
            className="flex items-center justify-center gap-2.5  font-semibold transition-all duration-300 group bg-text-button hover:bg-blue-700 cursor-pointer text-primary-text-white my-0 px-5 xl:pt-[12px] xl:pb-[10px] pt-[11px] pb-[9px] text-subtitle-3"
          >
            <a href={block?.link?.href ?? "#"} className="flex items-center">
              <Image
                src="/images/leadership/btn-linkedin.svg"
                alt="linkedin"
                className="h-[24px] w-[24px] lg:object-cover object-contain mr-[10px] mb-[3px]"
                width={24}
                height={24}
              />
              {block?.link?.label ?? "Schedule a Call"}
            </a>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="my-[3px]"
            >
              <path
                d="M1.25 9.6582H17.75"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
                className="lg:group-hover:opacity-100 xl:opacity-0 opacity-100 transition-all duration-300"
              ></path>
              <path
                d="M11.5908 2.5L18.7499 9.65909L11.5908 16.8181"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
                className="lg:group-hover:translate-x-0 xl:-translate-x-[3px] -translate-x-0 transition-all duration-300"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Feedback;
